
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/social-responsibility",
      function () {
        return require("private-next-pages/social-responsibility.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/social-responsibility"])
      });
    }
  